import utils from '../../../Shared/utils.jsx';

/**
 * True when an array's `items` schema maps to a single compact leaf editor (no nested PropertyGrid2).
 * Used by form2/array.jsx for one-row layout + arrayItemInline on leaves.
 */
export function isPrimitiveArrayItemSchema(itemsSchema) {
    if (!itemsSchema) return false;
    const el = utils.schema.resolve_Of(itemsSchema);
    if (!el || el.type === 'object' || el.type === 'array') return false;

    if (el.format === 'TextEditor') return false;
    if (el.format === 'HSMStatement_Schema') return false;
    if (el.format === 'ReferencedDocumentSchema' || el.format === 'nullableType') return false;

    if ('format' in el && el.format === 'LookupList') return true;

    switch (el.type) {
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
            return true;
        default:
            return false;
    }
}
